import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDynamicTranslations } from 'src/hooks/use-dynamic-translations ';
import { useSettings } from 'src/hooks/use-settings';
import Loader from 'src/pages/components/loader';

export default function AppLayout({ children }) {
  const { loading } = useDynamicTranslations();
  const { i18n } = useTranslation();
  const { handleUpdate, direction, isInitialized } = useSettings();

  useEffect(() => {
    if (isInitialized) {
      const currentDirection = i18n.language === 'ar' ? 'rtl' : 'ltr';
      if (currentDirection !== direction) {
        handleUpdate({ direction: currentDirection });
      }
    }
  }, [i18n.language, isInitialized, direction, handleUpdate]);

  if (loading) {
    return <Loader message="" />;
  }

  return <>{children}</>;
}
